import { z } from 'zod';
import { bilingueSchema } from './model/commun.js';
export const RUBRIQUES_CV = [
    'exposition_personnelle',
    'exposition_collective',
    'foire',
    'collection_publique',
    'prix',
    'residence',
    'formation',
    'publication',
];
export const saisieCvSchema = z.strictObject({
    annee: z
        .int()
        .min(1800)
        .refine((annee) => annee <= new Date().getFullYear() + 2, 'Année trop éloignée.'),
    rubrique: z.enum(RUBRIQUES_CV),
    intitule: bilingueSchema.refine((texte) => texte.fr.trim().length > 0, 'L’intitulé français est obligatoire.'),
    lieu: z.string().trim().max(200).default(''),
    ville: z.string().trim().max(200).default(''),
    pays: z
        .string()
        .regex(/^[A-Z]{2}$/, 'Code pays ISO à deux lettres attendu.')
        .optional(),
    masquee: z.boolean().default(false),
});
export const dossierArtisteSchema = z.strictObject({
    langue: z.enum(['fr', 'en']),
    oeuvreIds: z
        .array(z.string().regex(/^[a-fA-F0-9]{24}$/))
        .max(20)
        .refine((ids) => new Set(ids.map((id) => id.toLowerCase())).size === ids.length, 'Une œuvre ne peut figurer qu’une fois.'),
    avecPrix: z.boolean().default(false),
    avecPresse: z.boolean().default(false),
});
//# sourceMappingURL=cv-artiste.js.map